import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=d4ec0c12&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=d4ec0c12&prod&scoped=true&lang=css"
import style1 from "./NewsItem.vue?vue&type=style&index=1&id=d4ec0c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ec0c12",
  null
  
)

export default component.exports